<template>
  <!-- <ComponentDropdown></ComponentDropdown> -->
  <div class="zj-search-result-table">
    <el-table :data="tableData" @row-click="rowclick" :show-header="false">
      <el-table-column>
        <template slot-scope="scope">
          <ComponentInfoPanel
            type="MaterialStorage"
            v-bind:info="convert(scope.$index,scope.row)"
            v-bind:isMaterial="true"
          ></ComponentInfoPanel>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../../apis";
import ComponentInfoPanel from "./Component-InfoPanel";

export default {
  name: "ZjComponent-MaterialStorage",
  components: {
    ComponentInfoPanel: ComponentInfoPanel
  },
  props: {
    targetUri: Object,
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    },
    searchText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      selectData: null
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    convert(index, row) {
      var result = {
        index: row.OrderNum,
        id: row.WarehouseId,
        name: row.WarehouseName,
        contact: row.Contact,
        phone: row.Phone,
        longitude: row.Longitude,
        latitude: row.Latitude,
        distance: row.Distance,
        address: row.Address,
        childcount: row.MaterialTypesCount
      };
      return result;
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    search() {
      let searchInfo = {
        WarehouseName: this.searchText,
        Longitude: this.center[0] || 0,
        Latitude: this.center[1] || 0,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      new MyApis.MaterialWareHouseApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // eslint-disable-next-line no-unused-vars
    rowclick(row, column, e) {
      this.dispatch("ZjEmergencyOneMap", "poiselected", row.WarehouseId);
      this.dispatch("ZjEmergencyOperations", "poiselected", row.WarehouseId);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    }
  },
  watch: {
    center: function() {
      this.search();
    },
    searchText: function() {
      this.search();
    }
  }
};
</script>